module.exports = __webpack_public_path__ + "static/Truck35-5d562805715676648533aca39d562154.png";